import { RouteObject } from "react-router-dom";

export const WIRE_FX_RATES_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { WireFxRates } = await import("./WireFxRates");
      return { element: <WireFxRates /> };
    },
  },
  {
    path: "history",
    async lazy() {
      const { WireFxRatesHistory } = await import("./history/WireFxRatesHistory");
      return { element: <WireFxRatesHistory /> };
    },
  },
];
